import { Card } from "../../../../components/Card";
import { ReactComponent as StarIcon } from "../../../../assets/icons/star.svg";
import dayjs from "dayjs";
import { secondsToMinute } from "../../utils";
import { getStarCount } from "./Performance";

type Props = {
  report: any;
  score: number;
  avgScore: number;
  isPracticeSession: boolean;
};

export function InsightsOverviewCard({ report, score, avgScore, isPracticeSession }: Props) {
  return (
    <Card className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <div className="text-sm font-semibold text-text-primary">Overview</div>
        <div className="text-xs font-medium text-black">
          {dayjs(report?.session?.startTime?.seconds ? report.session.startTime.seconds * 1000 : report?.session?.startTime).format("MMM DD, YYYY")}
        </div>
      </div>
      <div className="flex gap-1.5">
        <div id="praxis-score" className="flex-1 bg-[#f4f4f5] rounded-md p-2 flex flex-col gap-0.5">
          <span className="text-xs text-[#71717a] leading-[1.3]">Session Score</span>
          {!isPracticeSession ? (
            <div className="flex items-center gap-1">
              <span className="text-xs font-semibold text-[#242424] leading-[1.3]">{score}</span>
              <div className="flex gap-0.5">
                {Array.from({ length: getStarCount(score) }).map((_, i) => (
                  <StarIcon key={i} className="!w-3 !h-3 [&_path]:fill-[#FACC15] [&_path]:stroke-none" />
                ))}
              </div>
            </div>
          ) : (
            <span className="text-xs text-gray-401 leading-[1.3]">—</span>
          )}
        </div>
        <div className="flex-1 bg-[#f4f4f5] rounded-md p-2 flex flex-col gap-0.5">
          <span className="text-xs text-[#71717a] leading-[1.3]">Avg. Score</span>
          {!isPracticeSession ? (
            <span className="text-xs font-semibold text-[#242424] leading-[1.3]">{avgScore}</span>
          ) : (
            <span className="text-xs text-gray-401 leading-[1.3]">—</span>
          )}
        </div>
        <div className="flex-1 bg-[#f4f4f5] rounded-md p-2 flex flex-col gap-0.5">
          <span className="text-xs text-[#71717a] leading-[1.3]">Session Time</span>
          <span className="text-xs font-semibold text-[#242424] leading-[1.3]">{secondsToMinute(report.duration)}</span>
        </div>
      </div>
    </Card>
  );
}
